module.exports = __webpack_public_path__ + "static/media/6.b7620446.jpg";